import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's129g-s129m01',
    templateUrl: './s129g-s129m01.component.html'
})
export class S129gS129m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    revnbr: any = {};
    coup1: any = {};
    coup2: any = {};
    coup3: any = {};
    coup4: any = {};
    coup5: any = {};
    coup6: any = {};
    coup7: any = {};
    coup8: any = {};
    msgln: any = {};
    selmen: any = {'value': '2-SEL'};
    iss: any = {'value': '5-ISS'};
    prev: any = {'value': '7-PREV'};
    next: any = {'value': '8-NEXT'};
    coupon: any = {'value': '9-COUPON'};
    usage: any = {'value': '10-USAGE'};
    currc1: any = {'value': 'SH4-CUST INQ'};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    paymt: any = {'value': 'SH5-PAYMT'};
    last: any = {'value': 'SH6-LAST'};
    first: any = {'value': 'SH7-FIRST'};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'revnbr', 'coup1', 'coup2', 'coup3', 'coup4', 'coup5', 'coup6', 'coup7', 'coup8', 'msgln', 'selmen', 'iss', 'prev', 'next', 'coupon', 'usage', 'currc1', 'prevc1', 'paymt', 'last', 'first'];
    public LINES: number[] = [1, 2, 4, 5, 7, 8, 10, 11, 13, 14, 16, 17, 21, 23, 24];

    ngAfterViewInit(): void {
    }
}
